"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const _S3 = /*#__PURE__*/ _interop_require_default(require("./S3"));
const _ncplugin = require("~/types/nc-plugin");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let S3Plugin = class S3Plugin extends _ncplugin.XcStoragePlugin {
    getAdapter() {
        return S3Plugin.storageAdapter;
    }
    async init(config) {
        S3Plugin.storageAdapter = new _S3.default(config);
        await S3Plugin.storageAdapter.init();
    }
};
const _default = S3Plugin;
